import React, { useEffect } from 'react'
import { HomeContainer } from './Home.styled'

import HomeSearch from './components/HomeSearch'
import HomeFacilities from './components/HomeFacilities'
import HomePricing from './HomePricing'
// import HomeTestimonial from './components/HomeTestimonial'
// import HomeLastestNews from './components/HomeLastestNews'
// import DropdownAction from 'components/DropdownAction/DropdownAction'
// import { DropdownActionOption } from 'components/DropdownAction'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'

function HomePage() {
  const { logEvent } = useAmplitude()

  useEffect(() => {
    logEvent(AMPLITUDE_EVENTS.LANDING_PAGE_EVENT)
  }, [])

  return (
    <HomeContainer>
      <HomeSearch />
      <HomeFacilities />
      {/* <HomeTestimonial /> */}      
      <HomePricing />
      {/* <HomeLastestNews /> */}
    </HomeContainer>
  )
}

export default HomePage
